export default __webpack_public_path__ + "static/media/drink.29fe35f1.png";